import { SmartTooltip } from '../../../../../components/SmartTooltip/SmartTooltip'
import { ReceiptGate } from '../../core/_models'

/**
 * CPAYMENT-1616: чек дошёл до оператора, но авто-проверка его так и не подтвердила.
 * Бейдж рядом с файлом отвечает на вопрос «почему этот чек здесь без подтверждения» — детали
 * самих проверок остаются в антифрод-сигнале, тут только причина пропуска.
 */
const REASON_TITLE: Record<ReceiptGate['reason'], string> = {
  unreadable: 'Документ не распознан',
  requisite_mismatch: 'Реквизит в чеке не совпал',
  no_verdict: 'Проверка не ответила',
  check_error: 'Проверка завершилась ошибкой',
}

const REASON_DETAIL: Record<ReceiptGate['reason'], string> = {
  unreadable:
    'Авто-проверка не смогла прочитать документ или это не чек. Тикет передан оператору по исчерпании попыток перезаливки.',
  requisite_mismatch:
    'Реквизит получателя в чеке отличается от реквизита тикета. Тикет передан оператору по исчерпании попыток перезаливки.',
  no_verdict:
    'Ответ авто-проверки не пришёл за отведённое время — тикет передан оператору по таймауту, чек не проверен.',
  check_error:
    'Авто-проверка завершилась ошибкой — тикет передан оператору, чек не проверен.',
}

// Жёлтый — «посмотри внимательнее», а не «всё плохо»: решение по чеку всё равно за оператором.
const REASON_COLOR: Record<ReceiptGate['reason'], string> = {
  unreadable: '#ffc107',
  requisite_mismatch: '#dc3545',
  no_verdict: '#6c757d',
  check_error: '#6c757d',
}

interface Props {
  gate: ReceiptGate | null | undefined
}

export const ReceiptGateBadge = ({ gate }: Props) => {
  if (!gate) {
    return null
  }

  const color = REASON_COLOR[gate.reason] ?? '#6c757d'

  const popover = (
    <div
      style={{
        backgroundColor: 'var(--bs-body-bg)',
        color: 'var(--bs-body-color)',
        border: '1px solid var(--bs-border-color)',
        borderRadius: 6,
        boxShadow: '0 2px 8px rgba(0,0,0,.15)',
        padding: '8px 12px',
        maxWidth: 320,
        fontSize: 12,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>
        Чек не подтверждён авто-проверкой
      </div>
      <div style={{ marginBottom: gate.reuploads > 0 ? 4 : 0 }}>
        {REASON_DETAIL[gate.reason] ?? REASON_TITLE[gate.reason]}
      </div>
      {gate.reuploads > 0 && (
        <div style={{ color: 'var(--bs-secondary-color)' }}>
          Клиент перезагружал чек: {gate.reuploads}
        </div>
      )}
    </div>
  )

  return (
    <SmartTooltip content={popover} bare>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '1px 6px',
          borderRadius: 10,
          border: `1px solid ${color}`,
          color,
          fontSize: 10,
          lineHeight: '14px',
          whiteSpace: 'nowrap',
          cursor: 'default',
        }}
      >
        ! {REASON_TITLE[gate.reason] ?? 'Не подтверждён'}
      </span>
    </SmartTooltip>
  )
}
